import(/* webpackMode: "eager" */ "/home/runner/work/oxpa.pro/oxpa.pro/src/app/(auth)/error.tsx");
